import { render } from "./tasks-modal.vue?vue&type=template&id=f8337ffa"
import script from "./tasks-modal.vue?vue&type=script&lang=js"
export * from "./tasks-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__